import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/familycrest`;

interface Props {
    className?: string;
}

export const FamilycrestInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            家紋印刷について
        </Title>
        <Image src={`${IMG_PATH}/familycrest.png`} />

        <Paragraph>
            羽の選択画面で「家紋印刷」とアイコンが表示されている羽根に家紋を印刷することができます。
            有名な戦国武将の家紋や幕末に活躍された著名人の家紋など有名どころを中心に
            厳選して揃えておりますので、ご自身のお好みの家紋をお選びください。
        </Paragraph>

        <Paragraph>
            印刷するインクの色は、印刷する羽の色が白系の色なら黒のインク、
            羽の色が黒系の色なら白のインク、また、どちらも共通して金と銀のインクでの印刷が可能です。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpFamilycrest: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <FamilycrestInner />
            </div>
        </div>
    </Panel>
);
